






















import Vue from 'vue'
import { mapGetters } from 'vuex'
export default Vue.extend({
    data: () => ({
        loading: false,
        registerCopy: `Prevent Your Messages from Getting Marked as SPAM - Register your Phone Line with Carriers Now.`,
        trialCopy: `Broadcast Messaging is limited to 50 contacts per message while on a free trial. Reach more contacts at once by starting your paid subscription`
    }),
    computed: {
        ...mapGetters([
            'authIsAdmin',
            'getEnabled',
            'getLimit',
            'getPlan',
            'plan',
            'productTier',
            'trialing'
        ]),
        a2pEnabled(): boolean {
            //  Check if A2P is enabled
            return this.getEnabled('a2p')
        },
        // Function pulls from api to get the settings data table to see if a user is a2p enabled or not
        a2pRegistered(): boolean {
            const a2pEnabled = this.$store.getters.settingGet('a2pEnabled')

            //  If our setting doesn't exist, return false
            if (!a2pEnabled) return false

            //  Else, return based on if we are enabled or not
            return !!a2pEnabled.enabled
        },
        bgColor(): string {
            //  If the broadcast limit is reached then show red
            if (this.broadcastLimitReached) return 'rgba(244, 67, 54, 0.35)'

            //  Else we can return our other color
            return '#F3EEEA'
        },
        broadcastBannerId(): string {
            //  Our id depends on our contactSales and contactSupport props
            const sales = this.contactSales
            const support = this.contactSupport

            //  If neither are true, return null
            if (!sales && !support) return null

            //  Else, support is 'contact-support'
            if (support) return 'contact-support'

            //  Else, sales is 'contact-sales'
            if (sales) return 'contact-sales'
        },
        broadcastLimit(): number {
            //  Check if we are trialing or not
            const trialing = this.trialing

            //  If we are, the limit is 50
            if (trialing) return 50

            //  Grab our limits
            return this.getLimit('broadcast') || 250
        },
        broadcastLimitReached(): boolean {
            //  If a2p is enabled, return false because we have no limits
            if (this.a2pEnabled) return false

            //  Else check the persons count
            const count = this.contactsCount

            //  Check if the count exceeds current limit
            return count > this.broadcastLimit
        },
        contactCopy(): string {
            //  If the auth user is NOT the admin then return our non-admin copy
            if (!this.authIsAdmin)
                return `This Broadcast exceeds your contact limit of ${this.broadcastLimit}. To proceed please have your admin upgrade your MessageDesk subscription.`

            //  Else, return the default copy
            return `This Broadcast exceeds your contact limit of ${this.broadcastLimit}. To proceed please upgrade to a larger contact limit or remove contacts from your Broadcast.`
        },
        contactsCount(): number {
            return this.$store.getters.broadcastsViewSelectedBroadcastTotalCount
        },
        contactSales(): boolean {
            //  Check if our broadcast limit reached
            const limitReached = this.broadcastLimitReached

            //  Check if we are on the Team plan
            const isTeam = this.productTier === 'Team'

            //  Base it on if both are true
            return limitReached && isTeam
        },
        contactSupport(): boolean {
            //  Check if our broadcast limit reached
            const limitReached = this.broadcastLimitReached

            //  Base it on if both are true
            return limitReached && !this.authIsAdmin
        },
        cta(): string {
            //  Check if our broadcast limit reached
            const limitReached = this.broadcastLimitReached

            //  Check if we reached our hard limit
            const hardLimitReached = this.hardLimitReached

            //  Check if we are on the Team plan
            const isTeam = this.productTier === 'Team'

            //  If we have reached the hard limit, it takes #1 priority just say "Contact Support" or "Contact Sales"
            if ((hardLimitReached || limitReached) && !this.authIsAdmin)
                return 'Contact Support'

            //  This is for admin users when hard limit is reached
            if (hardLimitReached) return 'Contact Sales'

            //  IF the above condition is true then we need to display 'Start Paid Subscription'
            if (this.trialing) return 'Start Paid Subscription'

            //  Else, if we reached our limit AND we are not on Team then display "Increase Contact Limit"
            if (limitReached && !isTeam) return 'Increase Contact Limit'

            //  Else if we are unregistered then return "Begin Phone Number Registration"
            if (!this.a2pRegistered) return 'Begin Phone Number Registration'
        },
        hardLimitReached(): boolean {
            //  If the contacts we are attempting to reach are over 2000 then we are at the absolute hard limit
            return this.contactsCount > 2000
        },
        iconColor(): string {
            //  If the broadcast limit is reached then show red
            if (this.broadcastLimitReached) return '#F44336'

            //  Else, return our yellow color
            return '#E7A730'
        },
        suggestedTier(): string {
            //  Grab our number we want to send to
            const count = this.contactsCount

            //  Check if we reached our hard limit
            const hardLimitReached = this.hardLimitReached

            //  Regardless if we have reached hard limit, return null
            if (hardLimitReached) return null

            //  Else, the tier to start on depends on the number they are attempting to send to
            if (count > 1000) return 'Team'

            //  If above 50 then suggest Operator
            if (count > 50) return 'Operator'

            //  Else, suggest their current tier
            return this.productTier
        },
        text(): string {
            //  If our contact limit is reached then return our contact copy
            if (this.broadcastLimitReached) return this.contactCopy

            //  Else, if we are trialing then return the trial text
            if (this.trialing) return this.trialCopy

            //  Else if we are unregistered, return our registration text
            if (!this.a2pRegistered) return this.registerCopy
        }
    },
    methods: {
        onClick(): void {
            //  Check if our broadcast limit reached
            const limitReached = this.broadcastLimitReached

            //  check if we reached our hard upper limit
            const hardLimitReached = this.hardLimitReached

            //  Check if we are on the Team plan
            const isTeam = this.productTier === 'Team'

            //  If we reached our limit and are NOT the admin display "Contact Support"
            if ((limitReached || hardLimitReached) && !this.authIsAdmin)
                return this.onContactSupport()

            //  If we reached our limit AND we are on Team then display "Contact Sales"
            if (hardLimitReached) return this.onContactSales()

            //  If we are trialing and  then return 'Start Paid Subscription'
            if (this.trialing) return this.onStartSubscription()

            //  Else, if we reached our limit AND we are not on Team then display "Increase Contact Limit"
            if (limitReached && !isTeam) return this.onUpdateSubscription()

            //  Else if we are unregistered then return "Begin Phone Number Registration"
            if (!this.a2pRegistered) return this.onRegisterNumber()
        },
        onContactSales(): void {
            console.log('contact sales')
        },
        onContactSupport(): void {
            console.log('contact support')
        },
        onRegisterNumber(): void {
            this.$store.dispatch('dialogOpen', {
                type: 'CONFIRM',
                title: 'Phone Number Registration',
                text: `Phone number registration gives your account access to verified delivery. Without registering, your messages may fail to deliver at a high rate or be delayed in reaching your contacts.
                        <br><br>
                        To register a phone line, you'll need important information such as:
                        <br><ul><li>
                        Your Organizations Tax ID (EIN), Organizations Address, among other items
                        </li></ul>`,
                icon: 'mdi-help-circle',
                color: 'primary',
                yesText: 'Proceed to Registration',
                hideNo: true,
                closeable: true,
                width: '650px',
                textStyle: false,
                callback: (proceed: boolean) => {
                    //  Depending on if we selected to proceed or not, upgrade
                    if (!proceed) return

                    //  Tell the parent we want to navigate to reg page
                    this.$emit('navigateAwaySet', '/brand-info')

                    //  Navigate away
                    this.$router.push('/brand-info')
                }
            })
        },
        onStartSubscription(): void {
            //  Our new tier depends on what tier we currently are at
            this.$store.dispatch('dialogOpen', {
                type: 'APP',
                title: 'Start Paid Subscription',
                icon: 'mdi-help-circle',
                color: 'primary',
                closeable: true,
                width: '650px',
                component: 'broadcast-form-popup',
                closeOnSubmit: true,
                props: {
                    tier: this.suggestedTier,
                    upgrade: false
                },
                callback: () => {
                    //  Then display a pop up about our success
                    this.$store.dispatch('dialogOpen', {
                        type: 'MESSAGE',
                        title: 'Update Successful',
                        text: 'Your account was successfully updated. To view your subscription with MessageDesk please navigate to Settings -> Subscription Settings.',
                        icon: 'mdi-help-circle',
                        color: 'primary',
                        width: '650px',
                        linkText: 'Close',
                        buttonProps: {
                            depressed: true,
                            width: 100
                        }
                    })
                }
            })
        },
        onUpdateSubscription(): void {
            //  Our new tier depends on what tier we currently are at
            const tier = {
                Starter: 'Operator',
                Operator: 'Team'
            }[this.productTier]

            this.$store.dispatch('dialogOpen', {
                type: 'APP',
                title: 'Upgrade Subscription',
                icon: 'mdi-help-circle',
                color: 'primary',
                closeable: true,
                width: '650px',
                component: 'broadcast-form-popup',
                closeOnSubmit: true,
                props: {
                    tier: tier,
                    upgrade: true
                },
                callback: () => {
                    //  Then display a pop up about our success
                    this.$store.dispatch('dialogOpen', {
                        type: 'MESSAGE',
                        title: 'Update Successful',
                        text: 'Your account was successfully updated. To view your subscription with MessageDesk please navigate to Settings -> Subscription Settings.',
                        icon: 'mdi-help-circle',
                        color: 'primary',
                        width: '650px',
                        linkText: 'Close',
                        buttonProps: {
                            depressed: true,
                            width: 100
                        }
                    })
                }
            })
        }
    }
})
